// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%2301257d%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/notifications.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #e5edf1;
  --surface: #ffffff;
  --surface-soft: #f6fbff;
  --border: #d0e3ec;
  --ink: #01257d;
  --muted: #51627d;
  --accent: #96c2db;
  --accent-strong: #4a82a8;
  --success: #2e8b57;
  --warning: #e0a100;
  --danger: #d44d4d;
  --shadow: 0 14px 34px rgba(1, 37, 125, 0.08);
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
  background: radial-gradient(circle at 20% 20%, rgba(150, 194, 219, 0.24), transparent 30%),
    radial-gradient(circle at 80% 0%, rgba(1, 37, 125, 0.08), transparent 32%),
    var(--bg);
  color: var(--ink);
  line-height: 1.6;
  min-height: 100vh;
}

a {
  color: var(--accent-strong);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  box-shadow: var(--shadow);
  padding: 14px 20px;
  position: sticky;
  top: 0;
  z-index: 50;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  color: var(--ink);
}

.brand-badge {
  background: linear-gradient(135deg, var(--accent), var(--accent-strong));
  color: white;
  padding: 6px 10px;
  border-radius: var(--radius-md);
  font-weight: 800;
  box-shadow: 0 8px 16px rgba(74, 130, 168, 0.28);
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--surface-soft);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 8px 12px;
  color: var(--muted);
  cursor: pointer;
  transition: all 0.2s ease;
}

.pill:hover {
  border-color: var(--accent);
  color: var(--ink);
  text-decoration: none;
  background: #eef6fb;
}

.pill.active {
  background: var(--accent);
  color: var(--ink);
  border-color: var(--accent-strong);
  box-shadow: 0 6px 18px rgba(74, 130, 168, 0.25);
}

.grid {
  display: grid;
  gap: 16px;
}

.grid-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 18px;
  box-shadow: var(--shadow);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 38px rgba(1, 37, 125, 0.12);
}

.shadow {
  box-shadow: var(--shadow);
}

.muted {
  color: var(--muted);
}

.h1 {
  font-size: 28px;
  font-weight: 800;
  margin: 0 0 8px;
  letter-spacing: -0.02em;
}

.h2 {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 6px;
}

.h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 4px;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, var(--accent), var(--accent-strong));
  border: none;
  color: var(--ink);
  padding: 10px 14px;
  border-radius: var(--radius-md);
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}

.btn:hover {
  text-decoration: none;
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(74, 130, 168, 0.32);
}

.btn.secondary {
  background: linear-gradient(135deg, #4a90e2, #96c2db);
  color: white;
}

.btn.ghost {
  background: transparent;
  border: 1px solid var(--border);
  color: var(--ink);
}

.btn.ghost:hover {
  border-color: var(--accent);
  color: var(--ink);
  transform: none;
  box-shadow: none;
  background: #eef6fb;
}

.btn.danger {
  background: linear-gradient(135deg, var(--danger), #b03131);
  color: white;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.form-group {
  margin-bottom: 16px;
}

.label {
  display: block;
  margin: 0 0 6px;
  color: var(--ink);
  font-weight: 600;
  font-size: 14px;
}

.input {
  width: 100%;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  color: var(--ink);
  padding: 12px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.input:focus {
  outline: none;
  border-color: var(--accent-strong);
  box-shadow: 0 0 0 3px rgba(150, 194, 219, 0.45);
}

.input.error {
  border-color: var(--danger);
}

.textarea {
  resize: vertical;
  min-height: 100px;
}

.select {
  width: 100%;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  color: var(--ink);
  padding: 12px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 10px center;
  background-repeat: no-repeat;
  background-size: 16px;
  padding-right: 32px;
}

.error-message {
  color: var(--danger);
  font-size: 12px;
  margin-top: 4px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  border-bottom: 1px solid var(--border);
  padding: 12px;
  text-align: left;
}

.table th {
  color: var(--muted);
  font-weight: 600;
  font-size: 14px;
}

.badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid var(--border);
  background: var(--surface-soft);
  color: var(--ink);
}

.badge.green {
  background: rgba(46, 139, 87, 0.08);
  color: #1e6f44;
  border-color: rgba(46, 139, 87, 0.22);
}

.badge.blue {
  background: rgba(150, 194, 219, 0.18);
  color: var(--accent-strong);
  border-color: rgba(150, 194, 219, 0.35);
}

.badge.gray {
  background: #f1f4f8;
  color: #6b7b95;
}

.badge.yellow {
  background: rgba(224, 161, 0, 0.12);
  color: #b48200;
  border-color: rgba(224, 161, 0, 0.32);
}

.badge.red {
  background: rgba(212, 77, 77, 0.12);
  color: #b23a3a;
  border-color: rgba(212, 77, 77, 0.32);
}

.badge.silver-badge {
  background: linear-gradient(135deg, #e9eef5, #c8d2e1);
  color: #2d3b53;
  border-color: #b7c3d5;
}

.footer {
  padding: 30px 20px;
  color: var(--muted);
  border-top: 1px solid var(--border);
  margin-top: auto;
  text-align: center;
  background: var(--surface);
}

.hero {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 24px;
  align-items: center;
  margin: 32px 0;
}

.kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.center {
  display: grid;
  place-items: center;
  min-height: 70vh;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--muted);
  padding: 20px;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid var(--border);
  border-top: 2px solid var(--accent-strong);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(1, 37, 125, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 24px;
  max-width: 520px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: var(--shadow);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.close-btn {
  background: none;
  border: none;
  color: var(--muted);
  font-size: 24px;
  cursor: pointer;
}

.close-btn:hover {
  color: var(--ink);
}

.alert {
  padding: 12px 16px;
  border-radius: var(--radius-md);
  margin: 16px 0;
  border: 1px solid var(--border);
  background: var(--surface-soft);
}

.alert.success {
  background: rgba(46, 139, 87, 0.1);
  color: #1e6f44;
  border-color: rgba(46, 139, 87, 0.2);
}

.alert.error {
  background: rgba(212, 77, 77, 0.1);
  color: #b23a3a;
  border-color: rgba(212, 77, 77, 0.2);
}

.alert.warning {
  background: rgba(224, 161, 0, 0.1);
  color: #b48200;
  border-color: rgba(224, 161, 0, 0.2);
}

.alert.info {
  background: rgba(150, 194, 219, 0.18);
  color: var(--accent-strong);
  border-color: rgba(150, 194, 219, 0.32);
}

.resume-reminder-banner {
  padding: 14px 24px 0;
}

.profile-completeness-card {
  background: linear-gradient(145deg, #ffffff, #f4f9fd);
}

.profile-completeness__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.profile-completeness__track {
  width: 100%;
  height: 12px;
  border-radius: 999px;
  overflow: hidden;
  background: #e8eef5;
  border: 1px solid #d4e0ea;
}

.profile-completeness__fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.35s ease;
}

.profile-completeness__fill--danger {
  background: linear-gradient(90deg, #d44d4d, #c53434);
}

.profile-completeness__fill--warning {
  background: linear-gradient(90deg, #e0a100, #c88a00);
}

.profile-completeness__fill--success {
  background: linear-gradient(90deg, #2e8b57, #1f6f43);
}

.saved-job--unavailable {
  opacity: 0.7;
  background: linear-gradient(180deg, #f3f4f6 0%, #e5e7eb 100%);
}

.password-field {
  position: relative;
  display: flex;
  align-items: center;
}

.password-field .input {
  padding-right: 42px;
}

.password-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--ink);
  font-size: 18px;
  padding: 4px;
  display: grid;
  place-items: center;
}

.password-toggle:hover {
  color: var(--ink);
}

.eye-icon {
  font-family: 'Segoe UI Symbol', 'Noto Sans Symbols', 'Arial Unicode MS', system-ui;
  font-size: 18px;
}

.password-requirements {
  margin: 8px 0 0;
  padding-left: 18px;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.5;
}

.password-requirements li {
  margin-bottom: 4px;
}

.password-requirements li.ok {
  color: #1e6f44;
  font-weight: 600;
}

.job-card {
  transition: all 0.2s ease;
  cursor: pointer;
}

.job-card:hover {
  transform: translateY(-2px);
  border-color: var(--accent);
}

.match-score {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.score-bar {
  flex: 1 1;
  height: 6px;
  background: #e0ebf4;
  border-radius: 3px;
  overflow: hidden;
}

.score-fill {
  height: 100%;
  background: linear-gradient(90deg, #f0c96a, var(--accent-strong));
  transition: width 0.3s ease;
}

.skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.skill-tag {
  background: var(--surface-soft);
  color: var(--ink);
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  border: 1px solid var(--border);
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 24px 0;
}

.pagination button {
  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--ink);
  padding: 8px 12px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.2s ease;
}

.pagination button:hover:not(:disabled) {
  background: var(--accent);
  color: var(--ink);
  border-color: var(--accent-strong);
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination button.active {
  background: var(--accent);
  color: var(--ink);
}

.search-filters {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: var(--shadow);
}

.filter-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: var(--muted);
}

.empty-state-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}

@media (max-width: 768px) {
  .container {
    padding: 16px;
  }

  .nav {
    padding: 12px 16px;
    flex-wrap: wrap;
  }

  .hero {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .grid-2,
  .grid-3,
  .grid-4 {
    grid-template-columns: 1fr;
  }

  .kpis {
    grid-template-columns: repeat(2, 1fr);
  }

  .filter-row {
    grid-template-columns: 1fr;
  }

  .modal {
    margin: 16px;
    width: calc(100% - 32px);
  }

  .pill {
    font-size: 14px;
    padding: 6px 10px;
  }

  .resume-reminder-banner {
    padding: 12px 16px 0;
  }
}

.card--toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  margin-bottom: 24px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
}

.card--toolbar .toolbar-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.card--toolbar .toolbar-title {
  font-weight: 600;
  color: var(--ink);
}

.card--toolbar .toolbar-subtitle {
  font-size: 12px;
  color: var(--muted);
}

.card--toolbar .toolbar-action {
  min-width: 200px;
}

.application-list {
  display: grid;
  gap: 16px;
}

.application-card {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.application-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.application-card__body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.application-card__title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
}

.application-card__title .h3 {
  margin: 0;
}

.application-card__meta {
  color: var(--muted);
  font-size: 13px;
}

.application-card__detail {
  color: var(--muted);
  font-size: 13px;
}

.application-card__detail strong {
  color: var(--ink);
}

.application-card__cover-letter strong {
  color: var(--ink);
}

.application-card__cover-letter {
  color: var(--muted);
  font-size: 13px;
  margin-top: 8px;
  white-space: pre-line;
}

.application-card__links {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  font-size: 13px;
}

.application-card__links a {
  color: var(--accent-strong);
  font-weight: 600;
}

.application-card__links a:hover {
  text-decoration: underline;
}

.application-card__actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  min-width: 140px;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
  border: 1px solid var(--border);
  background: var(--surface-soft);
  color: var(--ink);
}

.status-pill--blue {
  border-color: rgba(150, 194, 219, 0.6);
  background: rgba(150, 194, 219, 0.25);
  color: var(--accent-strong);
}

.status-pill--yellow {
  border-color: rgba(224, 161, 0, 0.4);
  background: rgba(224, 161, 0, 0.12);
  color: #b48200;
}

.status-pill--green {
  border-color: rgba(46, 139, 87, 0.4);
  background: rgba(46, 139, 87, 0.12);
  color: #1e6f44;
}

.status-pill--red {
  border-color: rgba(212, 77, 77, 0.4);
  background: rgba(212, 77, 77, 0.12);
  color: #b23a3a;
}

.status-pill--gray {
  border-color: var(--border);
  background: #f3f6f9;
  color: #6b7b95;
}

.card--empty {
  text-align: center;
  padding: 48px 24px;
}

.card--empty .h3 {
  margin-bottom: 8px;
}

.card--narrow {
  max-width: 480px;
  margin: 0 auto;
  text-align: center;
}

.card--narrow .btn,
.card--empty .btn {
  margin-top: 16px;
}

.avatar {
  border-radius: 50%;
  overflow: hidden;
  background: var(--surface-soft);
  border: 1px solid var(--border);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--ink);
  font-weight: 700;
  box-shadow: var(--shadow);
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pricing-page {
  padding-bottom: 24px;
}

.pricing-hero {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 88% 10%, rgba(74, 130, 168, 0.2), transparent 36%),
    radial-gradient(circle at 0% 90%, rgba(150, 194, 219, 0.34), transparent 42%),
    linear-gradient(140deg, #ffffff 0%, #f2f8fd 65%, #e6f1f8 100%);
}

.pricing-hero .h1 {
  max-width: 780px;
}

.pricing-hero__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
}

.pricing-grid {
  margin-top: 18px;
  gap: 18px;
}

.pricing-role-switch {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.pricing-card {
  position: relative;
  border-color: #c7dce8;
  background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
  max-width: 980px;
  width: 100%;
}

.pricing-card__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}

.pricing-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: #fff;
}

.pricing-table {
  min-width: 620px;
}

.pricing-table th:first-child,
.pricing-table td:first-child {
  width: 40%;
  font-weight: 600;
}

.pricing-table__silver {
  background: rgba(150, 194, 219, 0.18);
  border-left: 1px solid #c9ddea;
  font-weight: 700;
  color: var(--ink);
}

.pricing-card__cta {
  margin-top: 16px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.recruiter-buckets-page {
  padding-bottom: 28px;
}

.recruiter-buckets-layout {
  display: grid;
  grid-template-columns: minmax(220px, 280px) 1fr;
  gap: 16px;
}

@media (max-width: 768px) {
  .pricing-table {
    min-width: 560px;
  }

  .recruiter-buckets-layout {
    grid-template-columns: 1fr;
  }
}

.avatar--initials {
  text-transform: uppercase;
}

.job-manage-list {
  display: grid;
  gap: 16px;
}

.job-manage-card {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.job-manage-card__header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.job-manage-card__title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.job-manage-card__meta {
  color: var(--muted);
  font-size: 13px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.job-manage-card__meta--secondary {
  margin-top: 6px;
  font-size: 12px;
}

.job-manage-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.job-manage-card__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 13px;
  color: var(--muted);
}

.job-manage-card__description {
  font-size: 13px;
  color: var(--muted);
  margin: 0;
}

.pagination-card {
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 12px 16px;
}

.pagination-card .muted {
  font-size: 13px;
}

.btn.ghost-danger {
  color: var(--danger);
  border-color: rgba(212, 77, 77, 0.4);
}

.btn.ghost-danger:hover {
  color: var(--danger);
  border-color: var(--danger);
}

.input--compact {
  padding: 8px 12px;
  font-size: 13px;
}

.alert--stacked {
  margin-bottom: 16px;
}

.page-header {
  margin-bottom: 32px;
}

.page-header h1 {
  margin: 0 0 8px 0;
  color: var(--ink);
  font-size: 2rem;
}

.page-header p {
  margin: 0;
  color: var(--muted);
  font-size: 1.05rem;
}

.recruiter-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  background: linear-gradient(135deg, rgba(150, 194, 219, 0.4), rgba(1, 37, 125, 0.07));
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 24px 28px;
  box-shadow: var(--shadow);
}

.recruiter-page-header__copy {
  flex: 1 1 auto;
}

.recruiter-page-header__cta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}

.recruiter-page-header__hint {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--muted);
}

.recruiter-page-header .muted {
  max-width: 520px;
}

@media (max-width: 720px) {
  .recruiter-page-header {
    flex-direction: column;
    align-items: stretch;
  }

  .recruiter-page-header__cta {
    align-items: flex-start;
  }
}

.filters-section {
  background: var(--surface);
  border-radius: var(--radius-lg);
  padding: 24px;
  margin-bottom: 24px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.filters-actions {
  display: flex;
  gap: 12px;
  margin-top: 16px;
  flex-wrap: wrap;
}

.filters-actions .btn {
  min-width: 140px;
  justify-content: center;
}

.filter-group label {
  display: block;
  margin-bottom: 8px;
  color: var(--ink);
  font-weight: 500;
}

.filter-group input,
.filter-group select {
  width: 100%;
  padding: 10px 12px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--ink);
  font-size: 14px;
}

.filter-group input:focus,
.filter-group select:focus {
  outline: none;
  border-color: var(--accent-strong);
  box-shadow: 0 0 0 3px rgba(150, 194, 219, 0.35);
}

.results-summary {
  margin-bottom: 16px;
  color: var(--muted);
}

.btn.btn--cta {
  background: linear-gradient(135deg, var(--accent-strong), var(--accent));
  padding: 12px 24px;
  border-radius: 999px;
  font-size: 15px;
  box-shadow: 0 10px 18px rgba(1, 37, 125, 0.18);
}

.btn.btn--cta:hover {
  box-shadow: 0 14px 24px rgba(1, 37, 125, 0.24);
}

.table-container {
  background: var(--surface);
  border-radius: var(--radius-lg);
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  border: 1px solid var(--border);
  margin-bottom: 24px;
  box-shadow: var(--shadow);
}

.users-table,
.jobs-table {
  width: 100%;
  border-collapse: collapse;
}

.jobs-table {
  min-width: 1180px;
}

.jobs-table-container {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.jobs-table-container .jobs-table {
  width: max-content;
  min-width: 1320px;
}

.jobs-table-container .jobs-table th,
.jobs-table-container .jobs-table td {
  white-space: nowrap;
}

.users-table th,
.jobs-table th,
.users-table td,
.jobs-table td {
  padding: 16px;
  text-align: left;
  border-bottom: 1px solid var(--border);
}

/* Layout */
.app-shell {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 240px 1fr;
  background: var(--bg);
}

.app-shell.expanded {
  grid-template-columns: 80px 1fr;
}

.app-shell__content {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
}

.app-shell__content main {
  min-width: 0;
  flex: 1 0 auto;
}

.sidebar {
  position: sticky;
  top: 0;
  align-self: start;
  height: 100vh;
  width: 240px;
  background: var(--surface);
  border-right: 1px solid var(--border);
  padding: 22px 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: var(--shadow);
  transition: width 0.2s ease, padding 0.2s ease;
}

.sidebar.collapsed {
  width: 80px;
  padding: 22px 12px;
}

.sidebar__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.sidebar__brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-weight: 800;
  color: var(--ink);
  text-decoration: none;
}

.sidebar__nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--border) transparent;
}

.sidebar__nav::-webkit-scrollbar {
  width: 6px;
}

.sidebar__nav::-webkit-scrollbar-thumb {
  background: var(--border);
  border-radius: 3px;
}

.sidebar__nav::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar__link {
  display: inline-flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: var(--radius-md);
  color: var(--muted);
  border: 1px solid transparent;
  transition: all 0.2s ease;
  gap: 8px;
}

.sidebar__toggle {
  background: transparent;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 6px 8px;
  display: grid;
  gap: 4px;
  cursor: pointer;
}

.sidebar__toggle span {
  display: block;
  width: 16px;
  height: 2px;
  background: var(--ink);
}

.sidebar.collapsed .sidebar__link {
  justify-content: center;
}

.sidebar__link .sidebar__label {
  display: inline;
}

.sidebar.collapsed .sidebar__label {
  display: none;
}

.sidebar.collapsed .sidebar__brand span {
  display: none;
}

.sidebar__link:hover {
  background: var(--surface-soft);
  color: var(--ink);
  border-color: var(--border);
  text-decoration: none;
}

.sidebar__link.active {
  background: var(--accent);
  color: var(--ink);
  border-color: var(--accent-strong);
  box-shadow: 0 8px 18px rgba(74, 130, 168, 0.22);
}

.sidebar.collapsed .sidebar__link.active {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  padding: 12px 20px;
  box-shadow: var(--shadow);
  position: sticky;
  top: 0;
  z-index: 10;
}

.topbar__left {
  min-width: 38px;
  display: inline-flex;
  align-items: center;
}

.topbar__menu-btn {
  border: 1px solid var(--border);
  background: var(--surface-soft);
  color: var(--ink);
  border-radius: var(--radius-md);
  width: 38px;
  height: 38px;
  display: none;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-direction: column;
  cursor: pointer;
}

.topbar__menu-btn span {
  display: block;
  width: 16px;
  height: 2px;
  background: var(--ink);
}

.topbar__user-name {
  font-weight: 700;
  color: var(--ink);
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown {
  position: absolute;
  right: 10px;
  top: 58px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow);
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dropdown a {
  color: var(--ink);
  text-decoration: none;
  font-weight: 600;
}

.dropdown a:hover {
  color: var(--accent-strong);
}

.dropdown__link {
  background: transparent;
  border: none;
  text-align: left;
  padding: 8px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-weight: 600;
  color: var(--ink);
}

.dropdown__link:hover {
  background: var(--surface-soft);
}

.dropdown__link.danger {
  color: var(--danger);
}

.topbar__notif {
  position: relative;
  display: inline-block;
}

.topbar__help-icon {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: var(--surface-soft);
  color: var(--ink);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 18px;
  text-decoration: none;
}

.topbar__help-icon:hover {
  text-decoration: none;
  border-color: var(--accent);
  background: #eef6fb;
}

.topbar__icon {
  width: 36px;
  height: 36px;
  border: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/cover no-repeat;
  border-radius: 8px;
  display: grid;
  place-items: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(1, 37, 125, 0.1);
  padding: 0;
  position: relative;
}

.topbar__icon:hover {
  filter: brightness(0.95);
}

.icon-bell {
  width: 20px;
  height: 20px;
  display: block;
  background: transparent;
}

.notif-badge {
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: var(--accent-strong);
  color: white;
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -6px;
  right: -6px;
  box-shadow: 0 2px 6px rgba(74, 130, 168, 0.35);
  pointer-events: none;
}

.dropdown--notifications {
  right: 0;
  min-width: 260px;
  transform: translateX(-20%);
}

.dropdown__title {
  font-weight: 700;
  color: var(--ink);
  margin-bottom: 6px;
}

.notif__title {
  font-weight: 700;
  color: var(--ink);
}

.notif__message {
  font-size: 12px;
}

@media (max-width: 960px) {
  .app-shell {
    grid-template-columns: 1fr;
  }
  .app-shell.expanded {
    grid-template-columns: 1fr;
  }
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: min(84vw, 320px);
    height: 100dvh;
    z-index: 60;
    transform: translateX(-105%);
    transition: transform 0.24s ease;
    padding: 18px 14px;
    overflow-y: auto;
  }
  .sidebar.mobile-open {
    transform: translateX(0);
  }
  .sidebar.collapsed {
    width: min(84vw, 320px);
    padding: 18px 14px;
  }
  .sidebar.collapsed .sidebar__label,
  .sidebar.collapsed .sidebar__brand span {
    display: inline;
  }
  .sidebar__nav {
    flex-direction: column;
    gap: 6px;
  }
  .sidebar__link {
    padding: 11px 12px;
  }
  .sidebar__toggle {
    display: none;
  }
  .topbar__menu-btn {
    display: inline-flex;
  }
  .sidebar-backdrop {
    position: fixed;
    inset: 0;
    border: none;
    background: rgba(1, 19, 56, 0.38);
    z-index: 55;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }
  .topbar {
    padding: 10px 12px;
  }
  .topbar__user-name {
    display: none;
  }
  .topbar__left {
    min-width: auto;
  }
  .dropdown {
    right: 0;
    top: 52px;
    max-width: min(90vw, 320px);
  }
  .dropdown--notifications {
    transform: none;
  }
}

/* Charts */
.chart-card {
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
}

.chart-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.chart-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--surface-soft);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 4px 8px;
}

.chart-toggle button {
  border: none;
  background: transparent;
  color: var(--muted);
  padding: 8px 12px;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.chart-toggle button.active {
  background: var(--accent);
  color: var(--ink);
  box-shadow: 0 6px 16px rgba(74, 130, 168, 0.24);
}

.bar-chart {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 14px;
  align-items: end;
}

.bar-chart__column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.bar-chart__bar {
  width: 100%;
  min-height: 12px;
  border-radius: var(--radius-sm);
  background: linear-gradient(180deg, var(--accent), var(--accent-strong));
  box-shadow: 0 8px 16px rgba(74, 130, 168, 0.2);
  position: relative;
}

.bar-chart__count {
  font-weight: 700;
  color: var(--ink);
}

.bar-chart__label {
  font-size: 13px;
  color: var(--muted);
  text-align: center;
}

.bar-chart__empty {
  text-align: center;
  padding: 12px 0;
}

.pie-chart {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 16px;
  align-items: center;
}

.pie-chart__viz {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  border: 10px solid var(--border);
  display: grid;
  place-items: center;
  position: relative;
  background: var(--surface-soft);
}

.pie-chart__empty {
  font-size: 13px;
}

.pie-chart__legend {
  display: grid;
  gap: 10px;
}

.pie-chart__legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pie-chart__legend-swatch {
  width: 14px;
  height: 14px;
  border-radius: 4px;
  border: 1px solid var(--border);
}

.pie-chart__legend-title {
  font-weight: 600;
  color: var(--ink);
}

.pie-chart__legend-count {
  color: var(--muted);
  font-size: 13px;
}

.company-list {
  display: grid;
  gap: 12px;
}

.company-list__item {
  display: grid;
  grid-template-columns: 1fr 160px;
  gap: 12px;
  align-items: center;
}

.company-list__name {
  font-weight: 700;
  color: var(--ink);
}

.company-list__bar {
  width: 100%;
  height: 10px;
  background: var(--surface-soft);
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  overflow: hidden;
}

.company-list__bar-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--accent), var(--accent-strong));
  border-radius: var(--radius-md);
  transition: width 0.3s ease;
}

.sidebar__group {
  display: flex;
  flex-direction: column;
}

.sidebar__group-header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  background: none;
  border: none;
  color: var(--muted);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: var(--radius-md);
  transition: background 0.15s ease, color 0.15s ease;
}

.sidebar__group-header:hover {
  background: var(--surface-2, rgba(0, 0, 0, 0.03));
  color: var(--ink);
}

.sidebar__group-header:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 1px;
}

.sidebar__group-title {
  flex: 1 1;
  text-align: left;
}

.sidebar__group-badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--warning, #f59e0b);
}

.sidebar__group-chevron {
  display: inline-block;
  transition: transform 0.15s ease;
  font-size: 0.875rem;
  line-height: 1;
}

.sidebar__group-chevron.open {
  transform: rotate(90deg);
}

.sidebar__group-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 0 4px 8px;
}

.sidebar.collapsed .sidebar__group-header {
  display: none;
}

.sidebar.collapsed .sidebar__group-items {
  padding-left: 0;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,sEAAsE;EACtE;;aAEW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,sCAAsC;EACtC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wEAAwE;EACxE,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wEAAwE;EACxE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,yDAAmP;EACnP,sCAAsC;EACtC,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sCAAsC;EACtC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kFAAkF;EAClF,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iEAAiE;EACjE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB;;;kEAGgE;AAClE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,6DAA6D;EAC7D,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;AACX;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qFAAqF;EACrF,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wEAAwE;EACxE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;EAIE,aAAa;EACb,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,aAAa;EACb,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,0EAAoE;EACpE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,4BAA4B;IAC5B,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,iCAAiC;IACjC,WAAW;IACX,UAAU;IACV,SAAS;IACT,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;IACR,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,wEAAwE;EACxE,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uEAAuE;EACvE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,+BAA+B;EAC/B,mDAAmD;AACrD;;AAEA;EACE,iDAAiD;EACjD,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB","sourcesContent":[":root {\n  --bg: #e5edf1;\n  --surface: #ffffff;\n  --surface-soft: #f6fbff;\n  --border: #d0e3ec;\n  --ink: #01257d;\n  --muted: #51627d;\n  --accent: #96c2db;\n  --accent-strong: #4a82a8;\n  --success: #2e8b57;\n  --warning: #e0a100;\n  --danger: #d44d4d;\n  --shadow: 0 14px 34px rgba(1, 37, 125, 0.08);\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;\n  background: radial-gradient(circle at 20% 20%, rgba(150, 194, 219, 0.24), transparent 30%),\n    radial-gradient(circle at 80% 0%, rgba(1, 37, 125, 0.08), transparent 32%),\n    var(--bg);\n  color: var(--ink);\n  line-height: 1.6;\n  min-height: 100vh;\n}\n\na {\n  color: var(--accent-strong);\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 24px;\n}\n\n.nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n  box-shadow: var(--shadow);\n  padding: 14px 20px;\n  position: sticky;\n  top: 0;\n  z-index: 50;\n}\n\n.brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.brand-badge {\n  background: linear-gradient(135deg, var(--accent), var(--accent-strong));\n  color: white;\n  padding: 6px 10px;\n  border-radius: var(--radius-md);\n  font-weight: 800;\n  box-shadow: 0 8px 16px rgba(74, 130, 168, 0.28);\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--surface-soft);\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  padding: 8px 12px;\n  color: var(--muted);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.pill:hover {\n  border-color: var(--accent);\n  color: var(--ink);\n  text-decoration: none;\n  background: #eef6fb;\n}\n\n.pill.active {\n  background: var(--accent);\n  color: var(--ink);\n  border-color: var(--accent-strong);\n  box-shadow: 0 6px 18px rgba(74, 130, 168, 0.25);\n}\n\n.grid {\n  display: grid;\n  gap: 16px;\n}\n\n.grid-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.grid-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.grid-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 18px;\n  box-shadow: var(--shadow);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 18px 38px rgba(1, 37, 125, 0.12);\n}\n\n.shadow {\n  box-shadow: var(--shadow);\n}\n\n.muted {\n  color: var(--muted);\n}\n\n.h1 {\n  font-size: 28px;\n  font-weight: 800;\n  margin: 0 0 8px;\n  letter-spacing: -0.02em;\n}\n\n.h2 {\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0 0 6px;\n}\n\n.h3 {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 4px;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, var(--accent), var(--accent-strong));\n  border: none;\n  color: var(--ink);\n  padding: 10px 14px;\n  border-radius: var(--radius-md);\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n}\n\n.btn:hover {\n  text-decoration: none;\n  transform: translateY(-1px);\n  box-shadow: 0 8px 18px rgba(74, 130, 168, 0.32);\n}\n\n.btn.secondary {\n  background: linear-gradient(135deg, #4a90e2, #96c2db);\n  color: white;\n}\n\n.btn.ghost {\n  background: transparent;\n  border: 1px solid var(--border);\n  color: var(--ink);\n}\n\n.btn.ghost:hover {\n  border-color: var(--accent);\n  color: var(--ink);\n  transform: none;\n  box-shadow: none;\n  background: #eef6fb;\n}\n\n.btn.danger {\n  background: linear-gradient(135deg, var(--danger), #b03131);\n  color: white;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.form-group {\n  margin-bottom: 16px;\n}\n\n.label {\n  display: block;\n  margin: 0 0 6px;\n  color: var(--ink);\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.input {\n  width: 100%;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  color: var(--ink);\n  padding: 12px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.input:focus {\n  outline: none;\n  border-color: var(--accent-strong);\n  box-shadow: 0 0 0 3px rgba(150, 194, 219, 0.45);\n}\n\n.input.error {\n  border-color: var(--danger);\n}\n\n.textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.select {\n  width: 100%;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  color: var(--ink);\n  padding: 12px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%2301257d' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right 10px center;\n  background-repeat: no-repeat;\n  background-size: 16px;\n  padding-right: 32px;\n}\n\n.error-message {\n  color: var(--danger);\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table th,\n.table td {\n  border-bottom: 1px solid var(--border);\n  padding: 12px;\n  text-align: left;\n}\n\n.table th {\n  color: var(--muted);\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  border: 1px solid var(--border);\n  background: var(--surface-soft);\n  color: var(--ink);\n}\n\n.badge.green {\n  background: rgba(46, 139, 87, 0.08);\n  color: #1e6f44;\n  border-color: rgba(46, 139, 87, 0.22);\n}\n\n.badge.blue {\n  background: rgba(150, 194, 219, 0.18);\n  color: var(--accent-strong);\n  border-color: rgba(150, 194, 219, 0.35);\n}\n\n.badge.gray {\n  background: #f1f4f8;\n  color: #6b7b95;\n}\n\n.badge.yellow {\n  background: rgba(224, 161, 0, 0.12);\n  color: #b48200;\n  border-color: rgba(224, 161, 0, 0.32);\n}\n\n.badge.red {\n  background: rgba(212, 77, 77, 0.12);\n  color: #b23a3a;\n  border-color: rgba(212, 77, 77, 0.32);\n}\n\n.badge.silver-badge {\n  background: linear-gradient(135deg, #e9eef5, #c8d2e1);\n  color: #2d3b53;\n  border-color: #b7c3d5;\n}\n\n.footer {\n  padding: 30px 20px;\n  color: var(--muted);\n  border-top: 1px solid var(--border);\n  margin-top: auto;\n  text-align: center;\n  background: var(--surface);\n}\n\n.hero {\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  gap: 24px;\n  align-items: center;\n  margin: 32px 0;\n}\n\n.kpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.center {\n  display: grid;\n  place-items: center;\n  min-height: 70vh;\n}\n\n.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: var(--muted);\n  padding: 20px;\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--border);\n  border-top: 2px solid var(--accent-strong);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(1, 37, 125, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n}\n\n.modal {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 24px;\n  max-width: 520px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: var(--shadow);\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  color: var(--muted);\n  font-size: 24px;\n  cursor: pointer;\n}\n\n.close-btn:hover {\n  color: var(--ink);\n}\n\n.alert {\n  padding: 12px 16px;\n  border-radius: var(--radius-md);\n  margin: 16px 0;\n  border: 1px solid var(--border);\n  background: var(--surface-soft);\n}\n\n.alert.success {\n  background: rgba(46, 139, 87, 0.1);\n  color: #1e6f44;\n  border-color: rgba(46, 139, 87, 0.2);\n}\n\n.alert.error {\n  background: rgba(212, 77, 77, 0.1);\n  color: #b23a3a;\n  border-color: rgba(212, 77, 77, 0.2);\n}\n\n.alert.warning {\n  background: rgba(224, 161, 0, 0.1);\n  color: #b48200;\n  border-color: rgba(224, 161, 0, 0.2);\n}\n\n.alert.info {\n  background: rgba(150, 194, 219, 0.18);\n  color: var(--accent-strong);\n  border-color: rgba(150, 194, 219, 0.32);\n}\n\n.resume-reminder-banner {\n  padding: 14px 24px 0;\n}\n\n.profile-completeness-card {\n  background: linear-gradient(145deg, #ffffff, #f4f9fd);\n}\n\n.profile-completeness__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.profile-completeness__track {\n  width: 100%;\n  height: 12px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: #e8eef5;\n  border: 1px solid #d4e0ea;\n}\n\n.profile-completeness__fill {\n  height: 100%;\n  border-radius: 999px;\n  transition: width 0.35s ease;\n}\n\n.profile-completeness__fill--danger {\n  background: linear-gradient(90deg, #d44d4d, #c53434);\n}\n\n.profile-completeness__fill--warning {\n  background: linear-gradient(90deg, #e0a100, #c88a00);\n}\n\n.profile-completeness__fill--success {\n  background: linear-gradient(90deg, #2e8b57, #1f6f43);\n}\n\n.saved-job--unavailable {\n  opacity: 0.7;\n  background: linear-gradient(180deg, #f3f4f6 0%, #e5e7eb 100%);\n}\n\n.password-field {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-field .input {\n  padding-right: 42px;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--ink);\n  font-size: 18px;\n  padding: 4px;\n  display: grid;\n  place-items: center;\n}\n\n.password-toggle:hover {\n  color: var(--ink);\n}\n\n.eye-icon {\n  font-family: 'Segoe UI Symbol', 'Noto Sans Symbols', 'Arial Unicode MS', system-ui;\n  font-size: 18px;\n}\n\n.password-requirements {\n  margin: 8px 0 0;\n  padding-left: 18px;\n  color: var(--muted);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.password-requirements li {\n  margin-bottom: 4px;\n}\n\n.password-requirements li.ok {\n  color: #1e6f44;\n  font-weight: 600;\n}\n\n.job-card {\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.job-card:hover {\n  transform: translateY(-2px);\n  border-color: var(--accent);\n}\n\n.match-score {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.score-bar {\n  flex: 1;\n  height: 6px;\n  background: #e0ebf4;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.score-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #f0c96a, var(--accent-strong));\n  transition: width 0.3s ease;\n}\n\n.skills-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.skill-tag {\n  background: var(--surface-soft);\n  color: var(--ink);\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  border: 1px solid var(--border);\n}\n\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin: 24px 0;\n}\n\n.pagination button {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  color: var(--ink);\n  padding: 8px 12px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.pagination button:hover:not(:disabled) {\n  background: var(--accent);\n  color: var(--ink);\n  border-color: var(--accent-strong);\n}\n\n.pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination button.active {\n  background: var(--accent);\n  color: var(--ink);\n}\n\n.search-filters {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n  margin-bottom: 24px;\n  box-shadow: var(--shadow);\n}\n\n.filter-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--muted);\n}\n\n.empty-state-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n  }\n\n  .nav {\n    padding: 12px 16px;\n    flex-wrap: wrap;\n  }\n\n  .hero {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .grid-2,\n  .grid-3,\n  .grid-4 {\n    grid-template-columns: 1fr;\n  }\n\n  .kpis {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .filter-row {\n    grid-template-columns: 1fr;\n  }\n\n  .modal {\n    margin: 16px;\n    width: calc(100% - 32px);\n  }\n\n  .pill {\n    font-size: 14px;\n    padding: 6px 10px;\n  }\n\n  .resume-reminder-banner {\n    padding: 12px 16px 0;\n  }\n}\n\n.card--toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n}\n\n.card--toolbar .toolbar-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.card--toolbar .toolbar-title {\n  font-weight: 600;\n  color: var(--ink);\n}\n\n.card--toolbar .toolbar-subtitle {\n  font-size: 12px;\n  color: var(--muted);\n}\n\n.card--toolbar .toolbar-action {\n  min-width: 200px;\n}\n\n.application-list {\n  display: grid;\n  gap: 16px;\n}\n\n.application-card {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.application-card__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.application-card__body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.application-card__title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 0;\n}\n\n.application-card__title .h3 {\n  margin: 0;\n}\n\n.application-card__meta {\n  color: var(--muted);\n  font-size: 13px;\n}\n\n.application-card__detail {\n  color: var(--muted);\n  font-size: 13px;\n}\n\n.application-card__detail strong {\n  color: var(--ink);\n}\n\n.application-card__cover-letter strong {\n  color: var(--ink);\n}\n\n.application-card__cover-letter {\n  color: var(--muted);\n  font-size: 13px;\n  margin-top: 8px;\n  white-space: pre-line;\n}\n\n.application-card__links {\n  display: flex;\n  gap: 12px;\n  margin-top: 8px;\n  font-size: 13px;\n}\n\n.application-card__links a {\n  color: var(--accent-strong);\n  font-weight: 600;\n}\n\n.application-card__links a:hover {\n  text-decoration: underline;\n}\n\n.application-card__actions {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  min-width: 140px;\n}\n\n.status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border-radius: 999px;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: capitalize;\n  border: 1px solid var(--border);\n  background: var(--surface-soft);\n  color: var(--ink);\n}\n\n.status-pill--blue {\n  border-color: rgba(150, 194, 219, 0.6);\n  background: rgba(150, 194, 219, 0.25);\n  color: var(--accent-strong);\n}\n\n.status-pill--yellow {\n  border-color: rgba(224, 161, 0, 0.4);\n  background: rgba(224, 161, 0, 0.12);\n  color: #b48200;\n}\n\n.status-pill--green {\n  border-color: rgba(46, 139, 87, 0.4);\n  background: rgba(46, 139, 87, 0.12);\n  color: #1e6f44;\n}\n\n.status-pill--red {\n  border-color: rgba(212, 77, 77, 0.4);\n  background: rgba(212, 77, 77, 0.12);\n  color: #b23a3a;\n}\n\n.status-pill--gray {\n  border-color: var(--border);\n  background: #f3f6f9;\n  color: #6b7b95;\n}\n\n.card--empty {\n  text-align: center;\n  padding: 48px 24px;\n}\n\n.card--empty .h3 {\n  margin-bottom: 8px;\n}\n\n.card--narrow {\n  max-width: 480px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.card--narrow .btn,\n.card--empty .btn {\n  margin-top: 16px;\n}\n\n.avatar {\n  border-radius: 50%;\n  overflow: hidden;\n  background: var(--surface-soft);\n  border: 1px solid var(--border);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--ink);\n  font-weight: 700;\n  box-shadow: var(--shadow);\n}\n\n.avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.pricing-page {\n  padding-bottom: 24px;\n}\n\n.pricing-hero {\n  position: relative;\n  overflow: hidden;\n  background:\n    radial-gradient(circle at 88% 10%, rgba(74, 130, 168, 0.2), transparent 36%),\n    radial-gradient(circle at 0% 90%, rgba(150, 194, 219, 0.34), transparent 42%),\n    linear-gradient(140deg, #ffffff 0%, #f2f8fd 65%, #e6f1f8 100%);\n}\n\n.pricing-hero .h1 {\n  max-width: 780px;\n}\n\n.pricing-hero__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.pricing-grid {\n  margin-top: 18px;\n  gap: 18px;\n}\n\n.pricing-role-switch {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.pricing-card {\n  position: relative;\n  border-color: #c7dce8;\n  background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);\n  max-width: 980px;\n  width: 100%;\n}\n\n.pricing-card__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.pricing-table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: #fff;\n}\n\n.pricing-table {\n  min-width: 620px;\n}\n\n.pricing-table th:first-child,\n.pricing-table td:first-child {\n  width: 40%;\n  font-weight: 600;\n}\n\n.pricing-table__silver {\n  background: rgba(150, 194, 219, 0.18);\n  border-left: 1px solid #c9ddea;\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.pricing-card__cta {\n  margin-top: 16px;\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.recruiter-buckets-page {\n  padding-bottom: 28px;\n}\n\n.recruiter-buckets-layout {\n  display: grid;\n  grid-template-columns: minmax(220px, 280px) 1fr;\n  gap: 16px;\n}\n\n@media (max-width: 768px) {\n  .pricing-table {\n    min-width: 560px;\n  }\n\n  .recruiter-buckets-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.avatar--initials {\n  text-transform: uppercase;\n}\n\n.job-manage-list {\n  display: grid;\n  gap: 16px;\n}\n\n.job-manage-card {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.job-manage-card__header {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.job-manage-card__title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.job-manage-card__meta {\n  color: var(--muted);\n  font-size: 13px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.job-manage-card__meta--secondary {\n  margin-top: 6px;\n  font-size: 12px;\n}\n\n.job-manage-card__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.job-manage-card__stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  font-size: 13px;\n  color: var(--muted);\n}\n\n.job-manage-card__description {\n  font-size: 13px;\n  color: var(--muted);\n  margin: 0;\n}\n\n.pagination-card {\n  margin-top: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 12px 16px;\n}\n\n.pagination-card .muted {\n  font-size: 13px;\n}\n\n.btn.ghost-danger {\n  color: var(--danger);\n  border-color: rgba(212, 77, 77, 0.4);\n}\n\n.btn.ghost-danger:hover {\n  color: var(--danger);\n  border-color: var(--danger);\n}\n\n.input--compact {\n  padding: 8px 12px;\n  font-size: 13px;\n}\n\n.alert--stacked {\n  margin-bottom: 16px;\n}\n\n.page-header {\n  margin-bottom: 32px;\n}\n\n.page-header h1 {\n  margin: 0 0 8px 0;\n  color: var(--ink);\n  font-size: 2rem;\n}\n\n.page-header p {\n  margin: 0;\n  color: var(--muted);\n  font-size: 1.05rem;\n}\n\n.recruiter-page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  background: linear-gradient(135deg, rgba(150, 194, 219, 0.4), rgba(1, 37, 125, 0.07));\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 24px 28px;\n  box-shadow: var(--shadow);\n}\n\n.recruiter-page-header__copy {\n  flex: 1 1 auto;\n}\n\n.recruiter-page-header__cta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 12px;\n}\n\n.recruiter-page-header__hint {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--muted);\n}\n\n.recruiter-page-header .muted {\n  max-width: 520px;\n}\n\n@media (max-width: 720px) {\n  .recruiter-page-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .recruiter-page-header__cta {\n    align-items: flex-start;\n  }\n}\n\n.filters-section {\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  padding: 24px;\n  margin-bottom: 24px;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow);\n}\n\n.filters-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.filters-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n  flex-wrap: wrap;\n}\n\n.filters-actions .btn {\n  min-width: 140px;\n  justify-content: center;\n}\n\n.filter-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--ink);\n  font-weight: 500;\n}\n\n.filter-group input,\n.filter-group select {\n  width: 100%;\n  padding: 10px 12px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--ink);\n  font-size: 14px;\n}\n\n.filter-group input:focus,\n.filter-group select:focus {\n  outline: none;\n  border-color: var(--accent-strong);\n  box-shadow: 0 0 0 3px rgba(150, 194, 219, 0.35);\n}\n\n.results-summary {\n  margin-bottom: 16px;\n  color: var(--muted);\n}\n\n.btn.btn--cta {\n  background: linear-gradient(135deg, var(--accent-strong), var(--accent));\n  padding: 12px 24px;\n  border-radius: 999px;\n  font-size: 15px;\n  box-shadow: 0 10px 18px rgba(1, 37, 125, 0.18);\n}\n\n.btn.btn--cta:hover {\n  box-shadow: 0 14px 24px rgba(1, 37, 125, 0.24);\n}\n\n.table-container {\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  border: 1px solid var(--border);\n  margin-bottom: 24px;\n  box-shadow: var(--shadow);\n}\n\n.users-table,\n.jobs-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.jobs-table {\n  min-width: 1180px;\n}\n\n.jobs-table-container {\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n.jobs-table-container .jobs-table {\n  width: max-content;\n  min-width: 1320px;\n}\n\n.jobs-table-container .jobs-table th,\n.jobs-table-container .jobs-table td {\n  white-space: nowrap;\n}\n\n.users-table th,\n.jobs-table th,\n.users-table td,\n.jobs-table td {\n  padding: 16px;\n  text-align: left;\n  border-bottom: 1px solid var(--border);\n}\n\n/* Layout */\n.app-shell {\n  min-height: 100vh;\n  display: grid;\n  grid-template-columns: 240px 1fr;\n  background: var(--bg);\n}\n\n.app-shell.expanded {\n  grid-template-columns: 80px 1fr;\n}\n\n.app-shell__content {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-width: 0;\n}\n\n.app-shell__content main {\n  min-width: 0;\n  flex: 1 0 auto;\n}\n\n.sidebar {\n  position: sticky;\n  top: 0;\n  align-self: start;\n  height: 100vh;\n  width: 240px;\n  background: var(--surface);\n  border-right: 1px solid var(--border);\n  padding: 22px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-shadow: var(--shadow);\n  transition: width 0.2s ease, padding 0.2s ease;\n}\n\n.sidebar.collapsed {\n  width: 80px;\n  padding: 22px 12px;\n}\n\n.sidebar__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.sidebar__brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 800;\n  color: var(--ink);\n  text-decoration: none;\n}\n\n.sidebar__nav {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--border) transparent;\n}\n\n.sidebar__nav::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar__nav::-webkit-scrollbar-thumb {\n  background: var(--border);\n  border-radius: 3px;\n}\n\n.sidebar__nav::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar__link {\n  display: inline-flex;\n  align-items: center;\n  padding: 10px 12px;\n  border-radius: var(--radius-md);\n  color: var(--muted);\n  border: 1px solid transparent;\n  transition: all 0.2s ease;\n  gap: 8px;\n}\n\n.sidebar__toggle {\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 6px 8px;\n  display: grid;\n  gap: 4px;\n  cursor: pointer;\n}\n\n.sidebar__toggle span {\n  display: block;\n  width: 16px;\n  height: 2px;\n  background: var(--ink);\n}\n\n.sidebar.collapsed .sidebar__link {\n  justify-content: center;\n}\n\n.sidebar__link .sidebar__label {\n  display: inline;\n}\n\n.sidebar.collapsed .sidebar__label {\n  display: none;\n}\n\n.sidebar.collapsed .sidebar__brand span {\n  display: none;\n}\n\n.sidebar__link:hover {\n  background: var(--surface-soft);\n  color: var(--ink);\n  border-color: var(--border);\n  text-decoration: none;\n}\n\n.sidebar__link.active {\n  background: var(--accent);\n  color: var(--ink);\n  border-color: var(--accent-strong);\n  box-shadow: 0 8px 18px rgba(74, 130, 168, 0.22);\n}\n\n.sidebar.collapsed .sidebar__link.active {\n  background: transparent;\n  border-color: transparent;\n  box-shadow: none;\n}\n\n.topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n  padding: 12px 20px;\n  box-shadow: var(--shadow);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.topbar__left {\n  min-width: 38px;\n  display: inline-flex;\n  align-items: center;\n}\n\n.topbar__menu-btn {\n  border: 1px solid var(--border);\n  background: var(--surface-soft);\n  color: var(--ink);\n  border-radius: var(--radius-md);\n  width: 38px;\n  height: 38px;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  flex-direction: column;\n  cursor: pointer;\n}\n\n.topbar__menu-btn span {\n  display: block;\n  width: 16px;\n  height: 2px;\n  background: var(--ink);\n}\n\n.topbar__user-name {\n  font-weight: 700;\n  color: var(--ink);\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dropdown {\n  position: absolute;\n  right: 10px;\n  top: 58px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow);\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dropdown a {\n  color: var(--ink);\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.dropdown a:hover {\n  color: var(--accent-strong);\n}\n\n.dropdown__link {\n  background: transparent;\n  border: none;\n  text-align: left;\n  padding: 8px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-weight: 600;\n  color: var(--ink);\n}\n\n.dropdown__link:hover {\n  background: var(--surface-soft);\n}\n\n.dropdown__link.danger {\n  color: var(--danger);\n}\n\n.topbar__notif {\n  position: relative;\n  display: inline-block;\n}\n\n.topbar__help-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 999px;\n  border: 1px solid var(--border);\n  background: var(--surface-soft);\n  color: var(--ink);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 18px;\n  text-decoration: none;\n}\n\n.topbar__help-icon:hover {\n  text-decoration: none;\n  border-color: var(--accent);\n  background: #eef6fb;\n}\n\n.topbar__icon {\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: url('./assets/notifications.png') center/cover no-repeat;\n  border-radius: 8px;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  box-shadow: 0 4px 10px rgba(1, 37, 125, 0.1);\n  padding: 0;\n  position: relative;\n}\n\n.topbar__icon:hover {\n  filter: brightness(0.95);\n}\n\n.icon-bell {\n  width: 20px;\n  height: 20px;\n  display: block;\n  background: transparent;\n}\n\n.notif-badge {\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 999px;\n  background: var(--accent-strong);\n  color: white;\n  font-size: 10px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  box-shadow: 0 2px 6px rgba(74, 130, 168, 0.35);\n  pointer-events: none;\n}\n\n.dropdown--notifications {\n  right: 0;\n  min-width: 260px;\n  transform: translateX(-20%);\n}\n\n.dropdown__title {\n  font-weight: 700;\n  color: var(--ink);\n  margin-bottom: 6px;\n}\n\n.notif__title {\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.notif__message {\n  font-size: 12px;\n}\n\n@media (max-width: 960px) {\n  .app-shell {\n    grid-template-columns: 1fr;\n  }\n  .app-shell.expanded {\n    grid-template-columns: 1fr;\n  }\n  .sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: min(84vw, 320px);\n    height: 100dvh;\n    z-index: 60;\n    transform: translateX(-105%);\n    transition: transform 0.24s ease;\n    padding: 18px 14px;\n    overflow-y: auto;\n  }\n  .sidebar.mobile-open {\n    transform: translateX(0);\n  }\n  .sidebar.collapsed {\n    width: min(84vw, 320px);\n    padding: 18px 14px;\n  }\n  .sidebar.collapsed .sidebar__label,\n  .sidebar.collapsed .sidebar__brand span {\n    display: inline;\n  }\n  .sidebar__nav {\n    flex-direction: column;\n    gap: 6px;\n  }\n  .sidebar__link {\n    padding: 11px 12px;\n  }\n  .sidebar__toggle {\n    display: none;\n  }\n  .topbar__menu-btn {\n    display: inline-flex;\n  }\n  .sidebar-backdrop {\n    position: fixed;\n    inset: 0;\n    border: none;\n    background: rgba(1, 19, 56, 0.38);\n    z-index: 55;\n    padding: 0;\n    margin: 0;\n    cursor: pointer;\n  }\n  .topbar {\n    padding: 10px 12px;\n  }\n  .topbar__user-name {\n    display: none;\n  }\n  .topbar__left {\n    min-width: auto;\n  }\n  .dropdown {\n    right: 0;\n    top: 52px;\n    max-width: min(90vw, 320px);\n  }\n  .dropdown--notifications {\n    transform: none;\n  }\n}\n\n/* Charts */\n.chart-card {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow);\n}\n\n.chart-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.chart-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--surface-soft);\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  padding: 4px 8px;\n}\n\n.chart-toggle button {\n  border: none;\n  background: transparent;\n  color: var(--muted);\n  padding: 8px 12px;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.chart-toggle button.active {\n  background: var(--accent);\n  color: var(--ink);\n  box-shadow: 0 6px 16px rgba(74, 130, 168, 0.24);\n}\n\n.bar-chart {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 14px;\n  align-items: end;\n}\n\n.bar-chart__column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.bar-chart__bar {\n  width: 100%;\n  min-height: 12px;\n  border-radius: var(--radius-sm);\n  background: linear-gradient(180deg, var(--accent), var(--accent-strong));\n  box-shadow: 0 8px 16px rgba(74, 130, 168, 0.2);\n  position: relative;\n}\n\n.bar-chart__count {\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.bar-chart__label {\n  font-size: 13px;\n  color: var(--muted);\n  text-align: center;\n}\n\n.bar-chart__empty {\n  text-align: center;\n  padding: 12px 0;\n}\n\n.pie-chart {\n  display: grid;\n  grid-template-columns: 220px 1fr;\n  gap: 16px;\n  align-items: center;\n}\n\n.pie-chart__viz {\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n  border: 10px solid var(--border);\n  display: grid;\n  place-items: center;\n  position: relative;\n  background: var(--surface-soft);\n}\n\n.pie-chart__empty {\n  font-size: 13px;\n}\n\n.pie-chart__legend {\n  display: grid;\n  gap: 10px;\n}\n\n.pie-chart__legend-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pie-chart__legend-swatch {\n  width: 14px;\n  height: 14px;\n  border-radius: 4px;\n  border: 1px solid var(--border);\n}\n\n.pie-chart__legend-title {\n  font-weight: 600;\n  color: var(--ink);\n}\n\n.pie-chart__legend-count {\n  color: var(--muted);\n  font-size: 13px;\n}\n\n.company-list {\n  display: grid;\n  gap: 12px;\n}\n\n.company-list__item {\n  display: grid;\n  grid-template-columns: 1fr 160px;\n  gap: 12px;\n  align-items: center;\n}\n\n.company-list__name {\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.company-list__bar {\n  width: 100%;\n  height: 10px;\n  background: var(--surface-soft);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.company-list__bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--accent), var(--accent-strong));\n  border-radius: var(--radius-md);\n  transition: width 0.3s ease;\n}\n\n.sidebar__group {\n  display: flex;\n  flex-direction: column;\n}\n\n.sidebar__group-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 12px;\n  background: none;\n  border: none;\n  color: var(--muted);\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n  border-radius: var(--radius-md);\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.sidebar__group-header:hover {\n  background: var(--surface-2, rgba(0, 0, 0, 0.03));\n  color: var(--ink);\n}\n\n.sidebar__group-header:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 1px;\n}\n\n.sidebar__group-title {\n  flex: 1;\n  text-align: left;\n}\n\n.sidebar__group-badge-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--warning, #f59e0b);\n}\n\n.sidebar__group-chevron {\n  display: inline-block;\n  transition: transform 0.15s ease;\n  font-size: 0.875rem;\n  line-height: 1;\n}\n\n.sidebar__group-chevron.open {\n  transform: rotate(90deg);\n}\n\n.sidebar__group-items {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 4px 0 4px 8px;\n}\n\n.sidebar.collapsed .sidebar__group-header {\n  display: none;\n}\n\n.sidebar.collapsed .sidebar__group-items {\n  padding-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
